<template>
  <div class="container">
    <div class="flex-col mar-top-50">
      <div class="mar-bottom-50">
        <PageHeading
          :title="`ID: ${itemId}`"
          :description="'Details of the entity'"
          :tooltip="`Details of the entity with id ${itemId}`"
        />
      </div>
    </div>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
export default {
  computed: {
    entityId() {
      return this.$route.params.entity_id;
    },
    itemId() {
      return this.$route.params.item_id;
    },
  },
};
</script>

<style></style>
